import React from "react";

const PopularSearches = ({ searchQueries, days = 30 }) => {
  if (!searchQueries) {
    return null;
  }

  const { queries, takeaway, ownerMessage, setupRequired, connected, totalClicks } =
    searchQueries;

  if (setupRequired || !connected) {
    return (
      <article className="owner-dashboard__panel owner-dashboard__searches">
        <h3 className="owner-dashboard__panel-title">What families search on Google</h3>
        <p className="owner-dashboard__panel-subtitle">
          The exact phrases people type into Google before finding your website.
        </p>
        <p className="owner-dashboard__searches-note">
          {ownerMessage ||
            "Google search terms are not connected yet. Your web person can set this up in a few minutes — see the dashboard setup guide under Search Console."}
        </p>
      </article>
    );
  }

  if (!queries?.length) {
    return (
      <article className="owner-dashboard__panel owner-dashboard__searches">
        <h3 className="owner-dashboard__panel-title">What families search on Google</h3>
        <p className="owner-dashboard__panel-subtitle">
          Last {days} days · no Google search clicks recorded yet
        </p>
        <p className="owner-dashboard__searches-note">
          {ownerMessage ||
            "As more families find you through Google, the phrases they search for will appear here."}
        </p>
      </article>
    );
  }

  return (
    <article className="owner-dashboard__panel owner-dashboard__searches">
      <div className="owner-dashboard__panel-header owner-dashboard__panel-header--compact">
        <div>
          <h3 className="owner-dashboard__panel-title">What families search on Google</h3>
          <p className="owner-dashboard__panel-subtitle">
            Last {days} days · {totalClicks.toLocaleString()}{" "}
            {totalClicks === 1 ? "click" : "clicks"} from Google searches
          </p>
        </div>
      </div>

      <p className="owner-dashboard__searches-intro">
        These are the words and phrases people typed into Google before clicking
        through to your site — not what they searched for once they were already
        on ace-gymnastics.com.
      </p>

      {takeaway && <p className="owner-dashboard__searches-takeaway">{takeaway}</p>}

      <ul className="owner-dashboard__searches-list">
        {queries.slice(0, 8).map((row) => (
          <li key={row.query} className="owner-dashboard__searches-row">
            <div className="owner-dashboard__searches-row-head">
              <span className="owner-dashboard__searches-query">“{row.query}”</span>
              <span className="owner-dashboard__searches-stats">
                {row.clicks} {row.clicks === 1 ? "click" : "clicks"}
              </span>
            </div>
            {row.meaning && (
              <p className="owner-dashboard__searches-meaning">{row.meaning}</p>
            )}
            {row.impressions > 0 && (
              <p className="owner-dashboard__searches-meta">
                Seen in Google results {row.impressions.toLocaleString()} times
                {row.position ? ` · average position ${row.position}` : ""}
              </p>
            )}
          </li>
        ))}
      </ul>
    </article>
  );
};

export default PopularSearches;
